<div class="loader-container" *ngIf="isLoading()">
  <!-- <div class="logo-wrapper">
    <img src="assets/images/logo_full_900.png" alt="Company Logo" class="brand-logo">
    <div class="spinner"></div>
  </div> -->
  <mat-progress-bar mode="indeterminate" class="custom-gradient-loader"></mat-progress-bar>
</div>